import { render, staticRenderFns } from "./ManageCustomerForm.vue?vue&type=template&id=71225514&scoped=true"
import script from "./ManageCustomerForm.vue?vue&type=script&lang=js"
export * from "./ManageCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./ManageCustomerForm.vue?vue&type=style&index=0&id=71225514&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71225514",
  null
  
)

export default component.exports